import { useState, useEffect } from "react";

const useQuote = (quoteUuid) => {
  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchQuote = async () => {
      if (!quoteUuid) {
        setError("UUID da cotação não informado");
        setLoading(false);
        return;
      }

      const token = localStorage.getItem("authToken");
      
      if (!token) {
        setError("Token de autenticação não encontrado");
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_ENDPOINT}/webapp/find/quote/${quoteUuid}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "jwt": token,
            },
          }
        );
        
        const data = await response.json();

        if (data.success) {
          setQuote(data.quote);
        } else {
          setError(data.message || "Erro ao buscar cotação");
        }
      } catch (err) {
        setError("Erro ao buscar cotação. Tente novamente.");
      } finally {
        setLoading(false);
      }
    };

    fetchQuote();
  }, [quoteUuid]);

  return {
    quote,
    loading,
    error,
  };
};

export default useQuote;
